import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, CifraCargando, Group } from "@/components/ui";
import { ImportarExcelProveedores } from "./ImportarExcelProveedores";

export function ProveedoresHeader({
  total,
  activos,
  modoCrear,
  onIniciarCrear,
}: {
  /** undefined en la primera carga (sin caché) · se pinta una barra en vez de «0». */
  total: number | undefined;
  activos: number | undefined;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Proveedores"
      description={<>Catálogo · <CifraCargando valor={total} /> total · <CifraCargando valor={activos} /> activo(s) · varios proveedores pueden compartir RFC (decisión 44).</>}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          <ImportarExcelProveedores />
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo proveedor
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
